'use client';
import * as React from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const CollapsibleContext = /*#__PURE__*/ React.createContext(undefined);
CollapsibleContext.displayName = 'CollapsibleContext';
function useCollapsibleContext() {
    return useNonNullishContext(CollapsibleContext);
}

export { CollapsibleContext, useCollapsibleContext };
